
import Crud from '../components/AbsenceReason/Crud.vue'
import Add from '../components/AbsenceReason/Add.vue'
import Edit from '../components/AbsenceReason/Edit.vue'


let routes = {
    path: '/absence-reasons',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/absence-reasons',
            name: 'Motivos de Ausência',
            component: Crud
        },
        {
            path: '/absence-reasons/add',
            name: 'Novo Motivo de Ausência',
            component: Add
        },
        {
            path: '/absence-reasons/edit/:id',
            name: 'Editar Motivo de Ausência',
            component: Edit
        }
    ]
};

export default routes





// WEBPACK FOOTER //
// ./src/router/absence_reason.js